// import AddProsp1 from "../AppScreenshots/AddProsp/AddProsp1.jpg";
// import AddProsp2 from "../AppScreenshots/AddProsp/AddProsp2.jpg";
// import AddProsp3 from "../AppScreenshots/AddProsp/AddProsp3.jpg";

// import AddProspectNote1 from "../AppScreenshots/AddProspNote/AddNote1.jpg";
// import AddProspectNote2 from "../AppScreenshots/AddProspNote/AddNote2.jpg";
// import AddProspectNote3 from "../AppScreenshots/AddProspNote/AddNote3.jpg";
// import AddProspectNote4 from "../AppScreenshots/AddProspNote/AddNote4.jpg";
// import AddProspectNote5 from "../AppScreenshots/AddProspNote/AddNote5.jpg";

// import createEvent1 from "../AppScreenshots/CreateEvent/CreateEvent1.jpg";
// import createEvent2 from "../AppScreenshots/CreateEvent/CreateEvent2.jpg";
// import createEvent3 from "../AppScreenshots/CreateEvent/CreateEvent3.jpg";
// import createEvent4 from "../AppScreenshots/CreateEvent/CreateEvent4.jpg";
// import createEvent5 from "../AppScreenshots/CreateEvent/CreateEvent5.jpg";

// import assignCommittee1 from "../AppScreenshots/AssignCommitteeMembers/AddCommitteeMemeber1.jpg";
// import assignCommittee2 from "../AppScreenshots/AssignCommitteeMembers/AddCommitteeMemeber2.jpg";
// import assignCommittee3 from "../AppScreenshots/AssignCommitteeMembers/AddCommitteeMemeber3.jpg";
// import assignCommittee4 from "../AppScreenshots/AssignCommitteeMembers/AddCommitteeMemeber5.jpg";
// import assignCommittee5 from "../AppScreenshots/AssignCommitteeMembers/AddCommitteeMemeber5.jpg";

// import convertProspect1 from "../AppScreenshots/ConvertProspect/Asset 1-100.jpg";
// import convertProspect2 from "../AppScreenshots/ConvertProspect/Asset 2-100.jpg";
// import convertProspect3 from "../AppScreenshots/ConvertProspect/Asset 3-100.jpg";
// import convertProspect4 from "../AppScreenshots/ConvertProspect/Asset 4-100.jpg";

// import completeProspectAction1 from "../AppScreenshots/CheckoffProspAction/CheckoffAction1.jpg";
// import completeProspectAction2 from "../AppScreenshots/CheckoffProspAction/CheckoffAction2.jpg";
// import completeProspectAction3 from "../AppScreenshots/CheckoffProspAction/CheckoffAction3.jpg";

// import editProspectInfo1 from "../AppScreenshots/UpdateProspectInfo/UpdateProspectInfo1.jpg";
// import editProspectInfo2 from "../AppScreenshots/UpdateProspectInfo/UpdateProspectInfo2.jpg";
// import editProspectInfo3 from "../AppScreenshots/UpdateProspectInfo/UpdateProspectInfo3.jpg";
// import editProspectInfo4 from "../AppScreenshots/UpdateProspectInfo/UpdateProspectInfo4.jpg";

// import deleteProspect1 from "../AppScreenshots/DeleteProspect/DeleteProspect1.jpg";
// import deleteProspect2 from "../AppScreenshots/DeleteProspect/DeleteProspect2.jpg";
// import deleteProspect3 from "../AppScreenshots/DeleteProspect/DeleteProspect3.jpg";
// import deleteProspect4 from "../AppScreenshots/DeleteProspect/DeleteProspect4.jpg";

// import reorderBoards1 from "../AppScreenshots/ReorderBoards/ReorderBoard1.jpg";
// import reorderBoards2 from "../AppScreenshots/ReorderBoards/ReorderBoard2.jpg";
// import reorderBoards3 from "../AppScreenshots/ReorderBoards/ReorderBoard3.jpg";

// import placeBoards1 from "../AppScreenshots/PlaceBoards/PlaceBoards1.jpg";
// import placeBoards2 from "../AppScreenshots/PlaceBoards/PlaceBoards2.jpg";
// import placeBoards3 from "../AppScreenshots/PlaceBoards/PlaceBoards3.jpg";
// import placeBoards4 from "../AppScreenshots/PlaceBoards/PlaceBoards4.jpg";
// import placeBoards5 from "../AppScreenshots/PlaceBoards/PlaceBoards5.jpg";

// import joinTeam1 from "../AppScreenshots/JoinTeam/JoinTeam1.jpg";
// import joinTeam2 from "../AppScreenshots/JoinTeam/JoinTeam2.jpg";
// import joinTeam3 from "../AppScreenshots/JoinTeam/JoinTeam3.jpg";
// import joinTeam4 from "../AppScreenshots/JoinTeam/JoinTeam4.jpg";

// import createBoard1 from "../AppScreenshots/CreateBoard/CreateBoard1.jpg"; 
// import createBoard2 from "../AppScreenshots/CreateBoard/CreateBoard2.jpg"; 
// import createBoard3 from "../AppScreenshots/CreateBoard/CreateBoard3.jpg"; 
// import createBoard4 from "../AppScreenshots/CreateBoard/CreateBoard4.jpg";

// import createChat1 from "../AppScreenshots/CreateChat/CreateChat1.jpg";
// import createChat2 from "../AppScreenshots/CreateChat/CreateChat2.jpg";
// import createChat3 from "../AppScreenshots/CreateChat/CreateChat3.jpg";
// import createChat4 from "../AppScreenshots/CreateChat/CreateChat4.jpg";

// import shareTeamLink1 from "../AppScreenshots/ShareTeamLink/ShareTeamLink1.jpg";
// import shareTeamLink2 from "../AppScreenshots/ShareTeamLink/ShareTeamLink2.jpg";

// import switchTeams1 from "../AppScreenshots/SwitchTeams/SwitchTeams1.jpg";
// import switchTeams2 from "../AppScreenshots/SwitchTeams/SwitchTeams2.jpg";
// import switchTeams3 from "../AppScreenshots/SwitchTeams/SwitchTeams3.jpg";

// import viewTeamChat1 from "../AppScreenshots/ViewTeamChat/ViewTeamChat1.jpg";
// import viewTeamChat2 from "../AppScreenshots/ViewTeamChat/ViewTeamChat2.jpg";
// import viewTeamChat3 from "../AppScreenshots/ViewTeamChat/ViewTeamChat3.jpg";

// import scheduleCall1 from "../AppScreenshots/ScheduleCall/ScheduleCall1.jpg";
// import scheduleCall2 from "../AppScreenshots/ScheduleCall/ScheduleCall2.jpg";
// import scheduleCall3 from "../AppScreenshots/ScheduleCall/ScheduleCall3.jpg";
// import scheduleCall4 from "../AppScreenshots/ScheduleCall/ScheduleCall4.jpg";
// import scheduleCall5 from "../AppScreenshots/ScheduleCall/ScheduleCall5.jpg";
// import scheduleCall6 from "../AppScreenshots/ScheduleCall/ScheduleCall6.jpg";

// import searchBoard1 from "../AppScreenshots/SearchBoards/SearchBoards1.jpg";
// import searchBoard2 from "../AppScreenshots/SearchBoards/SearchBoards2.jpg";

// import reorderDashboard1 from "../AppScreenshots/ReorderDashboard/ReorderDashboard1.jpg";
// import reorderDashboard2 from "../AppScreenshots/ReorderDashboard/ReorderDashboard2.jpg";
// import reorderDashboard3 from "../AppScreenshots/ReorderDashboard/ReorderDashboard3.jpg";

// import updateAcccount1 from "../AppScreenshots/UpdateAccount/UpdateAccount1.jpg";
// import updateAcccount2 from "../AppScreenshots/UpdateAccount/UpdateAccount2.jpg";
// import updateAcccount3 from "../AppScreenshots/UpdateAccount/UpdateAccount3.jpg";
// import updateAcccount4 from "../AppScreenshots/UpdateAccount/UpdateAccount4.jpg";

// import upgradeSub1 from "../AppScreenshots/UpgradeSubscription/UpgradeSub1.jpg";
// import upgradeSub2 from "../AppScreenshots/UpgradeSubscription/UpgradeSub2.jpg";
// import upgradeSub3 from "../AppScreenshots/UpgradeSubscription/UpgradeSub3.jpg";
// import upgradeSub4 from "../AppScreenshots/UpgradeSubscription/UpgradeSub4.jpg";

// import dashboardStats1 from "../AppScreenshots/DashboardStats/DashboardStats1.jpg";
// import dashboardStats2 from "../AppScreenshots/DashboardStats/DashboardStats2.jpg";
// import dashboardStats3 from "../AppScreenshots/DashboardStats/DashboardStats3.jpg";
// import dashboardStats4 from "../AppScreenshots/DashboardStats/DashboardStats4.jpg";
// import dashboardStats5 from "../AppScreenshots/DashboardStats/DashboardStats5.jpg";

// import teamChatNotif1 from "../AppScreenshots/TeamChatNotifications/ChatNotifs1.jpg";
// import teamChatNotif2 from "../AppScreenshots/TeamChatNotifications/ChatNotifs2.jpg";
// import teamChatNotif3 from "../AppScreenshots/TeamChatNotifications/ChatNotifs3.jpg";

// import scheduleReminder1 from "../AppScreenshots/ScheduleReminder/ScheduleReminder1.jpg";
// import scheduleReminder2 from "../AppScreenshots/ScheduleReminder/ScheduleReminder2.jpg";
// import scheduleReminder3 from "../AppScreenshots/ScheduleReminder/ScheduleReminder3.jpg";
// import scheduleReminder4 from "../AppScreenshots/ScheduleReminder/ScheduleReminder4.jpg";
// import scheduleReminder5 from "../AppScreenshots/ScheduleReminder/ScheduleReminder5.jpg";
// import scheduleReminder6 from "../AppScreenshots/ScheduleReminder/ScheduleReminder6.jpg";
// import scheduleReminder7 from "../AppScreenshots/ScheduleReminder/ScheduleReminder7.jpg";

// import createLanguage1 from "../AppScreenshots/CreateLanguageBoard/CreateLanguage1.jpg";
// import createLanguage2 from "../AppScreenshots/CreateLanguageBoard/CreateLanguage2.jpg";
// import createLanguage3 from "../AppScreenshots/CreateLanguageBoard/CreateLanguage3.jpg";
// import createLanguage4 from "../AppScreenshots/CreateLanguageBoard/CreateLanguage4.jpg";
// import createLanguage5 from "../AppScreenshots/CreateLanguageBoard/CreateLanguage5.jpg";

// import createLink1 from "../AppScreenshots/CreateLinkBoard/CreateLinkBoard1.jpg";
// import createLink2 from "../AppScreenshots/CreateLinkBoard/CreateLinkBoard2.jpg";
// import createLink3 from "../AppScreenshots/CreateLinkBoard/CreateLinkBoard3.jpg";
// import createLink4 from "../AppScreenshots/CreateLinkBoard/CreateLinkBoard4.jpg";

// import createPhoto1 from "../AppScreenshots/CreatePhotoBoard/CreatePhotoBoard1.jpg";
// import createPhoto2 from "../AppScreenshots/CreatePhotoBoard/CreatePhotoBoard2.jpg";
// import createPhoto3 from "../AppScreenshots/CreatePhotoBoard/CreatePhotoBoard3.jpg";
// import createPhoto4 from "../AppScreenshots/CreatePhotoBoard/CreatePhotoBoard4.jpg";

// import createChecklist1 from "../AppScreenshots/CreateChecklistBoard/checklistboard1.jpg";
// import createChecklist2 from "../AppScreenshots/CreateChecklistBoard/checklistboard2.jpg";
// import createChecklist3 from "../AppScreenshots/CreateChecklistBoard/checklistboard3.jpg";
// import createChecklist4 from "../AppScreenshots/CreateChecklistBoard/checklistboard4.jpg";
// import createChecklist5 from "../AppScreenshots/CreateChecklistBoard/checklistboard5.jpg";
// import createChecklist6 from "../AppScreenshots/CreateChecklistBoard/checklistboard6.jpg";

// import boardListItem1 from "../AppScreenshots/BoardsListDBitem/BoardsListDBItem1.5.jpg";
// import boardListItem2 from "../AppScreenshots/BoardsListDBitem/BoardsListDBItem2.jpg";
// import boardListItem3 from "../AppScreenshots/BoardsListDBitem/BoardsListDBItem3.jpg";
// import boardListItem4 from "../AppScreenshots/BoardsListDBitem/BoardsListDBItem4.jpg";
// import boardListItem5 from "../AppScreenshots/BoardsListDBitem/BoardsListDBItem5.jpg";
// import boardListItem6 from "../AppScreenshots/BoardsListDBitem/BoardsListDBItem6.jpg";

// import linkDBItem1 from "../AppScreenshots/LinkDBitem/LinkDBitem1.jpg";
// import linkDBItem2 from "../AppScreenshots/LinkDBitem/LinkDBitem2.jpg";
// import linkDBItem3 from "../AppScreenshots/LinkDBitem/LinkDBitem3.jpg";
// import linkDBItem4 from "../AppScreenshots/LinkDBitem/LinkDBitem4.jpg";
// import linkDBItem5 from "../AppScreenshots/LinkDBitem/LinkDBitem5.jpg";

// import graphicDBItem1 from "../AppScreenshots/GraphicDBitem/GraphicDBitem1.jpg";
// import graphicDBItem2 from "../AppScreenshots/GraphicDBitem/GraphicDBitem2.jpg";
// import graphicDBItem3 from "../AppScreenshots/GraphicDBitem/GraphicDBitem3.jpg";
// import graphicDBItem4 from "../AppScreenshots/GraphicDBitem/GraphicDBitem4.jpg";
// import graphicDBItem5 from "../AppScreenshots/GraphicDBitem/GraphicDBitem5.jpg";

// import photoGridDBItem1 from "../AppScreenshots/PhotogridDBitem/PhotogridDBitem1.jpg";
// import photoGridDBItem2 from "../AppScreenshots/PhotogridDBitem/PhotogridDBitem2.jpg";
// import photoGridDBItem3 from "../AppScreenshots/PhotogridDBitem/PhotogridDBitem3.jpg";
// import photoGridDBItem4 from "../AppScreenshots/PhotogridDBitem/PhotogridDBitem4.jpg";
// import photoGridDBItem5 from "../AppScreenshots/PhotogridDBitem/PhotogridDBitem5.jpg";
// import photoGridDBItem6 from "../AppScreenshots/PhotogridDBitem/PhotogridDBitem6.jpg";

// import labelDBItem1 from "../AppScreenshots/LabelDBitem/LabelDBitem1.jpg";
// import labelDBItem2 from "../AppScreenshots/LabelDBitem/LabelDBitem2.jpg";
// import labelDBItem3 from "../AppScreenshots/LabelDBitem/LabelDBitem3.jpg";
// import labelDBItem4 from "../AppScreenshots/LabelDBitem/LabelDBitem4.jpg";
// import labelDBItem5 from "../AppScreenshots/LabelDBitem/LabelDBitem5.jpg";

// import createBarChart1 from "../AppScreenshots/CreateBarChart/CreateBarChart1.jpg";
// import createBarChart2 from "../AppScreenshots/CreateBarChart/CreateBarChart2.jpg";
// import createBarChart3 from "../AppScreenshots/CreateBarChart/CreateBarChart3.jpg";
// import createBarChart4 from "../AppScreenshots/CreateBarChart/CreateBarChart4.jpg";
// import createBarChart5 from "../AppScreenshots/CreateBarChart/CreateBarChart5.jpg";

// import prospListDBitem1 from "../AppScreenshots/ProspListDBitem/ProspListDBitem1.jpg";
// import prospListDBitem2 from "../AppScreenshots/ProspListDBitem/ProspListDBitem2.jpg";
// import prospListDBitem3 from "../AppScreenshots/ProspListDBitem/ProspListDBitem3.jpg";
// import prospListDBitem4 from "../AppScreenshots/ProspListDBitem/ProspListDBitem4.jpg";

// import createSpacer1 from "../AppScreenshots/CreateSpacerDBitem/CreateSpacer1.jpg";
// import createSpacer2 from "../AppScreenshots/CreateSpacerDBitem/CreateSpacer2.jpg";
// import createSpacer3 from "../AppScreenshots/CreateSpacerDBitem/CreateSpacer3.jpg";
// import createSpacer4 from "../AppScreenshots/CreateSpacerDBitem/CreateSpacer4.jpg";

// import addCommittee1 from "../AppScreenshots/AddCommittee/AddCommittee1.jpg";
// import addCommittee2 from "../AppScreenshots/AddCommittee/AddCommittee2.jpg";
// import addCommittee3 from "../AppScreenshots/AddCommittee/AddCommittee3.jpg";

// import addProduct1 from "../AppScreenshots/AddProduct/AddProduct1.jpg";
// import addProduct2 from "../AppScreenshots/AddProduct/AddProduct2.jpg";
// import addProduct3 from "../AppScreenshots/AddProduct/AddProduct3.jpg";

// import addAction1 from "../AppScreenshots/AddAction/AddAction1.jpg";
// import addAction2 from "../AppScreenshots/AddAction/AddAction2.jpg";
// import addAction3 from "../AppScreenshots/AddAction/AddAction3.jpg";
// import addAction4 from "../AppScreenshots/AddAction/AddAction4.jpg";

// import addGoal1 from "../AppScreenshots/AddGoal/AddGoal1.jpg";
// import addGoal2 from "../AppScreenshots/AddGoal/AddGoal2.jpg";
// import addGoal3 from "../AppScreenshots/AddGoal/AddGoal3.jpg";

// import createTeam1 from "../AppScreenshots/CreateTeam/Asset 1-100.jpg";
// import createTeam2 from "../AppScreenshots/CreateTeam/Asset 2-100.jpg";
// import createTeam3 from "../AppScreenshots/CreateTeam/Asset 3-100.jpg";
// import createTeam4 from "../AppScreenshots/CreateTeam/Asset 4-100.jpg";
// import createTeam5 from "../AppScreenshots/CreateTeam/Asset 5-100.jpg";
// import createTeam6 from "../AppScreenshots/CreateTeam/Asset 6-100.jpg";
// import createTeam7 from "../AppScreenshots/CreateTeam/Asset 7-100.jpg";

import Dashboard1 from "../AppScreenshots/StediDashboard/Dashboard1.jpg";
import Dashboard2 from "../AppScreenshots/StediDashboard/Dashboard2.jpg";
import Dashboard3 from "../AppScreenshots/StediDashboard/Dashboard3.jpg";
import Dashboard4 from "../AppScreenshots/StediDashboard/Dashboard4.jpg";
import Dashboard5 from "../AppScreenshots/StediDashboard/Dashboard5.jpg";
import Dashboard6 from "../AppScreenshots/StediDashboard/Dashboard6.jpg";
import Dashboard7 from "../AppScreenshots/StediDashboard/Dashboard7.jpg";

import Resources1 from "../AppScreenshots/StediResources/Resources1.jpg"
import Resources2 from "../AppScreenshots/StediResources/Resources2.jpg"
import Resources3 from "../AppScreenshots/StediResources/Resources3.jpg"
import Resources4 from "../AppScreenshots/StediResources/Resources4.jpg"

import CreateResource1 from "../AppScreenshots/StediCreateResource/CreateResource1.jpg"
import CreateResource2 from "../AppScreenshots/StediCreateResource/CreateResource2.jpg"
import CreateResource3 from "../AppScreenshots/StediCreateResource/CreateResource3.jpg"
import CreateResource4 from "../AppScreenshots/StediCreateResource/CreateResource4.jpg"

import CreateContact1 from "../AppScreenshots/StediCreateContact/CreateContact1.jpg"
import CreateContact2 from "../AppScreenshots/StediCreateContact/CreateContact2.jpg"
import CreateContact3 from "../AppScreenshots/StediCreateContact/CreateContact3.jpg"
import CreateContact4 from "../AppScreenshots/StediCreateContact/CreateContact4.jpg"

import CreateEvent1 from "../AppScreenshots/StediCreateEvent/CreateEvent1.jpg"
import createEvent2 from "../AppScreenshots/StediCreateEvent/CreateEvent2.jpg"
import CreateEvent3 from "../AppScreenshots/StediCreateEvent/CreateEvent3.jpg"
import CreateEvent4 from "../AppScreenshots/StediCreateEvent/CreateEvent4.jpg"

import StediRsvp1 from "../AppScreenshots/StediRsvp/StediRsvp1.jpg"
import StediRsvp2 from "../AppScreenshots/StediRsvp/StediRsvp2.jpg"
import StediRsvp3 from "../AppScreenshots/StediRsvp/StediRsvp3.jpg"

import StediJoinTeam1 from "../AppScreenshots/StediJoinTeam/StediJoinTeam1.jpg"
import StediJoinTeam2 from "../AppScreenshots/StediJoinTeam/StediJoinTeam2.jpg"
import StediJoinTeam3 from "../AppScreenshots/StediJoinTeam/StediJoinTeam3.jpg"


export const tutorials = [
  {
    title: "Navigate Your Dashboard",
    // body: "Learn how to add a new prospect by entering their name, category, and product interest, then view and manage them in your active prospects list.",
    steps: [
      {
        text: "1. Select the 'Dashboard' icon from the bottom tool bar. This will display the current dashboard the team creator has customized",
        images: [Dashboard1]
      },
      {
        text: "2. Scroll to view with all the dashboard items available. Tap a 'Board' item to open it and interact further with the content",
        images: [Dashboard2, Dashboard3],
      },
      {
        text: "3. Tap to open an image on the dashboarrd. Use the icons in the top right to download to your camera roll or send it to a friend",
        images: [Dashboard4, Dashboard5],
      },
      {
        text: "4. To view the dashboard of a diffent team, select the dropdown menu located at the top of your screen",
        images: [Dashboard6],
      },
      {
        text: "5. A list will appear displaying all teams you are a part of. Simply tap on the new team you wish to view",
        images: [Dashboard7],
      },
    ],
    basicSub: true
  },
  {
    title: "View Team Resources",
    // body: "Learn how to add a new prospect by entering their name, category, and product interest, then view and manage them in your active prospects list.",
    steps: [
      {
        text: "1. Select the 'Resources' icon from the bottom tool bar, this will display a list of all team boards. Tap on a board to open and interact with its inner content",
        images: [Resources1]
      },
      {
        text: "2. This will display the inner board contents, such as language boards, images, links, and more! Tap on an item to open it",
        images: [Resources2],
      },
      {
        text: "3. Share the resource with another user or team by selecting the icon in the top right",
        images: [Resources3],
      },
      {
        text: "4. Search for the users you wish to share with and tap the '+' icon, then click 'Share Resource",
        images: [Resources4],
      },
    ],
    basicSub: true
  },
  {
    title: "Create a Team Resource",
    // body: "Learn how to add a new prospect by entering their name, category, and product interest, then view and manage them in your active prospects list.",
    steps: [
      {
        text: "1. Select the 'Resources' icon from the bottom tool bar, then tap the board where you want to create the new resource",
        images: [CreateResource1]
      },
      {
        text: "2. Tap the '+' button at the bottom, then select the resource type you wish to create",
        images: [CreateResource2],
      },
      {
        text: "3. Enter your needed information. For a language resource, input a title and the relevant language in the text field and optionally link other resources. Tap 'Publish' when you're finished.",
        images: [CreateResource3],
      },
      {
        text: "4. The new resource will appear in the list of items under the chosen board",
        images: [CreateResource4],
      },
    ],
    basicSub: true
  },
  {
    title: "Create a Contact",
    // body: "Learn how to add a new prospect by entering their name, category, and product interest, then view and manage them in your active prospects list.",
    steps: [
      {
        text: "1. Select the 'Contacts' icon from the bottom tool bar to open your contacts list, then tap the '+' icon in the top right corner",
        images: [CreateContact1]
      },
      {
        text: "2. A new form will appear. Enter the new contact's name and other relevant information. Use the 'Category' and 'Product Interest' drop down menus to better classify your contact if necessary.",
        images: [CreateContact2],
      },
      {
        text: "3. After tapping 'Add', the new contact's profile will display. Here, you can track actions taken for the contact, add notes, or schedule calls that sync with your Apple calendar",
        images: [CreateContact3],
      },
      {
        text: "4. Your new contact will now appear in your list when you select the 'Contacts' icon",
        images: [CreateContact4],
      },
    ],
    basicSub: true
  },
  {
    title: "Create an Event",
    // body: "Learn how to add a new prospect by entering their name, category, and product interest, then view and manage them in your active prospects list.",
    steps: [
      {
        text: "1. Select the 'Events' icon from the bottom tool bar, then tap the '+' button",
        images: [CreateEvent1]
      },
      {
        text: "2. A new Event form will appear. Use the dropdown menu to select the team to post this event to, then fill out the fields with your even information. Tap 'Create Event' when you're ready to post",
        images: [createEvent2, CreateEvent3],
      },
      {
        text: "3. The Event is now displayed in the list. Other team members can use the 'RSVP' button to confirm their attendance and receive a reminder 30 minutes before the event",
        images: [CreateEvent4],
      }
    ],
    basicSub: true
  },
  {
    title: "RSVP to an Event",
    // body: "Learn how to add a new prospect by entering their name, category, and product interest, then view and manage them in your active prospects list.",
    steps: [
      {
        text: "1. Select the 'Resources' icon from the bottom tool bar, then locate the Event in the list and tap the 'RSVP' button",
        images: [StediRsvp1]
      },
      {
        text: "2. You will see an icon tracking the attendee count for this event. Tap this icon to view other users attending",
        images: [StediRsvp2],
      },
      {
        text: "3. Other attendees are displayed. If you have calendar access enabled, you will receive a notification 30 minutes before the event starts",
        images: [StediRsvp3],
      },
    ],
    basicSub: true
  },
  {
    title: "Join a New Team",
    // body: "Learn how to add a new prospect by entering their name, category, and product interest, then view and manage them in your active prospects list.",
    steps: [
      {
        text: "1. From the 'Dashboard' or 'Resources' tab, select the team dropdown at the top of the screen which is showing your current team",
        images: [StediJoinTeam1]
      },
      {
        text: "2. Tap the 'Join Team' button in the top right of the screen",
        images: [StediJoinTeam2],
      },
      {
        text: "3. Get the team name and password from an Admin. Enter the Team name and password, then tap 'Join'. You'll now see the new team's dashboard and have access to the teams resources.",
        images: [StediJoinTeam3],
      },
    ],
    basicSub: true
  },
  // {
  //   title: "Create a Team",
  //   // body: "Learn how to add a new prospect by entering their name, category, and product interest, then view and manage them in your active prospects list.",
  //   steps: [
  //     {
  //       text: "1. Select the 'Resources' icon from the bottom tool bar. ",
  //       images: []
  //     },
  //     {
  //       text: "",
  //       images: [],
  //     },
  //     {
  //       text: "",
  //       images: [],
  //     },
  //     {
  //       text: "",
  //       images: [],
  //     },
  //   ],
  //   basicSub: true
  // },
]









//   {
//     title: "Add Prospect Notes",
//     body: "Add a note to a prospect with a title, optional description, and reminder. Sync it with Apple Reminders to stay on top of important follow-ups.",
//     steps: [
//       {
//         text: "1. Select the ‘Prospects’ tab at the bottom, then tap on the prospect you want to add a note for",
//         images: [AddProspectNote1],
//       },
//       {
//         text: "2. Select section labeled ‘Notes’ on your prospect’s profile, then tap the ‘+’ button to open a new sheet.",
//         images: [AddProspectNote2],
//       },
//       {
//         text: "3. Enter a Title in the first input field and optionally, give a brief description in the second text field if you have more details. ",
//         images: [AddProspectNote3],
//       },
//       {
//         text: "4. If you like this to be a reminder and sync up with the Apple Reminders app on your device, switch the toggle on for ‘Set Reminder’",
//         images: [],
//       },
//       {
//         text: "5. use the date picker to choose your preferred date and time. Click the date or time fields to make a selection.",
//         images: [AddProspectNote4],
//       },
//       {
//         text: "6. Choose the frequency of this reminder with the checkmark buttons, you can select this to be a one time reminder or to occur every month",
//         images: [AddProspectNote4],
//       },
//       {
//         text: "7. Tap the ‘Add Note’ button at the bottom. This will now appear in the notes section on your prospect’s profile. If you chose this to be a reminder, go to the ‘Reminders’ app on your device, you will see the new prospect note in your list!",
//         images: [AddProspectNote5],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Create an Event",
//     body: "Create a team event by adding a title, details, location or link, and time. Customize with an emoji, then publish it to your shared event list.",
//     steps: [
//       {
//         text: "1. Tap the ‘Resources’ tab from the options at the bottom. Select the Calendar icon at the top.",
//         images: [createEvent1],
//       },
//       {
//         text: "2. In top right corner of this new screen, select the ‘+’ button to open a new form sheet.",
//         images: [createEvent2],
//       },
//       {
//         text: "3. Start by entering a title for your event in the first field. Then, add a brief description in the next field to provide more details.",
//         images: [createEvent3],
//       },
//       {
//         text: "4. Use the toggle to select in-person or virtual. For in-person events, type the address and choose from the dropdown. For virtual events, paste the meeting link in the field.",
//         images: [createEvent4],
//       },
//       {
//         text: "5. Next, use the date picker to choose your preferred date and time. Click the date or time fields to make a selection. Use the Duration slider to adjust the length of your event.",
//         images: [],
//       },
//       {
//         text: "6. Optionally, choose an emoji to display on your event by clicking the circular button at the bottom to open an emoji picker. Click on your preferred emoji.",
//         images: [],
//       },
//       {
//         text: "7. Select the ‘Create Event’ button at the bottom. You will see your new event in the list and it is visible to the members on your team",
//         images: [createEvent5],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Assign Committee Members",
//     body: "Assign a team member to a committee by selecting their name, choosing a committee, and setting their access level as a viewer or editor of its resources.",
//     steps: [
//       {
//         text: "1. Select the Resources tab at the bottom of the screen, then tap the gear icon in the top right.",
//         images: [assignCommittee1],
//       },
//       {
//         text: "2. Tap the Members label in the top right corner to open a list of all the team members.",
//         images: [assignCommittee2],
//       },
//       {
//         text: '3. Scroll or use the search bar to find the member, then tap the button labeled "None" with the down arrow next to their name. A new sheet will open with all available committees.',
//         images: [assignCommittee3],
//       },
//       {
//         text: '4. Identify the committee, then tap the red arrow next to it. It will turn into a checkmark, and a "Viewer" label with a checkbox will appear—showing the member can view the committee’s resources.',
//         images: [assignCommittee4],
//       },
//       {
//         text: '5. To grant the member access to contribute and edit the committee-specific resources, simply tap the checkbox labeled "Editor and Viewer".',
//         images: [assignCommittee5],
//       },
//     ],
//   },
//   {
//     title: "Convert a Prospect",
//     body: "Update a prospect’s status from the Prospects tab to reflect progress. Related resources will appear, and the prospect moves to your Conversions list automatically.",
//     steps: [
//       {
//         text: "1. Tap the ‘Prospects’ tab at the bottom, then select the active prospect you need to update.",
//         images: [convertProspect1],
//       },
//       {
//         text: "2. The 'Status' tab will appear as selected, with the available options displayed. To update the Prospect status, simply tap an option from the list",
//         images: [convertProspect2],
//       },
//       {
//         text: "3. The new status selected will be highlighted. Additionally, a list of resources related to your prospect’s new status will appear under the status if any exist — tap to view them.",
//         images: [convertProspect3],
//       },
//       {
//         text: "4. The prospect you updated will now appear in your ‘Conversions’ list!",
//         images: [convertProspect4],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Check Off Actions",
//     body: "Complete an action for a prospect by selecting them, tapping the Actions tab, and marking an item as done. It will appear checked on their profile.",
//     steps: [
//       {
//         text: "1. Select the ‘Prospects’ tab at the bottom, then tap on the prospect you want to add a note for.",
//         images: [completeProspectAction1],
//       },
//       {
//         text: "2. Select the 'Actions' tab from the four options. All available actions to take on your prospect are displayed in this list, organized by team.",
//         images: [completeProspectAction2],
//       },
//       {
//         text: "3. Tap the circle next to an Action to mark it complete. It’ll appear checked off now on the prospect. See the help text below for more details.",
//         images: [completeProspectAction3],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Edit a Prospect",
//     body: "Update a prospect’s info, modifying fields as needed, then closing the form to automatically save changes to their profile.",
//     steps: [
//       {
//         text: "1. Tap the ‘Prospects’ tab at the bottom, then select the prospect you need to update.",
//         images: [editProspectInfo1],
//       },
//       {
//         text: "2. In the top right corner, tap the ‘pen and paper’ icon. This will open a form with all of the current prospect information.",
//         images: [editProspectInfo2],
//       },
//       {
//         text: "3. Locate the prospect info you wish to update in the form and simply tap on it to either edit the information in the input field or select a new item from the dropdowns.",
//         images: [editProspectInfo3],
//       },
//       {
//         text: "4. When done editing the prospect, tap the ‘X’ button in the top right corner. This will save the information and close the sheet. The updates are now on your prospect’s profile.",
//         images: [editProspectInfo4],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Delete a Prospect",
//     body: "Remove a prospect from your list by accessing their profile and confirming deletion. This helps keep your active prospect list organized and up to date.",
//     steps: [
//       {
//         text: "1. Tap the ‘Prospects’ tab at the bottom, then select the prospect you want to delete.",
//         images: [deleteProspect1],
//       },
//       {
//         text: "2. In the top right corner, tap the ‘pen and paper’ icon. This will open a new sheet with the prospect’s information.",
//         images: [deleteProspect2],
//       },
//       {
//         text: "3. At the top of this sheet, tap the red ‘Delete’ button. When prompted to confirm or go back, select ‘Delete’. The sheet will close and the prospect is now removed from your list.",
//         images: [deleteProspect3, deleteProspect4],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Reorder Boards",
//     body: "Reorganize your boards by entering reorder mode, dragging them into your preferred order, and saving the layout to customize how content is displayed in Resources.",
//     steps: [
//       {
//         text: "Select the ‘Resources’ tab at the bottom, then tap the ‘Edit Boards’ button in the top right.",
//         images: [reorderBoards1],
//       },
//       {
//         text: "2. A new item will appear with two options labeled ‘Reorder Mode’ and ‘Place Mode’. Ensure ‘Reorder Mode’ is highlighted. Tap the ‘?’ icon for more information.",
//         images: [reorderBoards2],
//       },
//       {
//         text: "3. To reorder, press and hold a board, then drag it to your desired position. Other boards will automatically adjust as you move it.",
//         images: [reorderBoards3],
//       },
//       {
//         text: "4. When you’re done reordering your boards, tap the ‘Done’ button in the top right corner to save your board order!",
//         images: [],
//       },
//     ],
//   },
//   {
//     title: 'Nest Boards with Place Mode',
//     body: "Use Place Mode to organize your boards hierarchically by nesting one board inside another. This helps structure your Resources section for easier navigation.",
//     steps: [
//       {
//         text: '1. Select the ‘Resources’ tab at the bottom, then tap the ‘Edit Boards’ button in the top right.',
//         images: [placeBoards1],
//       },
//       {
//         text: '2. A new item will appear with two options labeled ‘Reorder Mode’ and ‘Place Mode’. Tap on ‘Place Mode’ to select this option. Tap the ‘?’ icon for more information.',
//         images: [placeBoards2],
//       },
//       {
//         text: '3. To nest a board inside another, press and hold the board you want to move, then drag it over the target board and release it.',
//         images: [placeBoards3],
//       },
//       {
//         text: '4. When you’re finished placing your boards, tap the ‘Done’ button in the top right to save your changes.',
//         images: [placeBoards4],
//       },
//       {
//         text: '5. Tap the board you dropped into, and you’ll see the one you moved is now inside it.',
//         images: [placeBoards5],
//       },
//     ],
//   },
//   {
//     title: "Create New Board",
//     body: "Create a new board by entering a title, selecting an emoji, and setting access permissions for committees. The board will then appear in your team resources.",
//     steps: [
//       {
//         text: "1. Tap the ‘Resources’ tab at the bottom of the screen, then click the circular ‘+’ button. This will open a new sheet titled ‘Create Board’.",
//         images: [createBoard1], 
//       },
//       {
//         text: "2. In the input field, enter your board title. Click on the auto generated emoji to choose a custom board emoji from the list.",
//         images: [createBoard2],
//       },
//       {
//         text: "3. Next, choose who can view and post on this board. If you select ‘Specific Committees’, you’ll be asked to choose which committees should have full access. Select them from the list and click ‘Done’.",
//         images: [createBoard3],
//       },
//       {
//         text: "4. You’ll then be asked to assign view-only access. Simply follow the same steps to select the appropriate access. After choosing who can access this board, click ‘Create board’. This board will now appear in your team resources.",
//         images: [createBoard4],
//       },
//     ],
//   },
//   {
//     title: "Join a New Team",
//     body: "Join a new team by entering an invite code from your team leader. Once joined, you’ll gain access to that team’s resources and collaboration features.",
//     steps: [
//       {
//         text: "1. Tap the ‘Resources’ tab from the four options at the bottom of the screen. In the top left corner, you’ll see your current team name with a dropdown arrow—Click on this.",
//         images: [joinTeam1], 
//       },
//       {
//         text: "2. A sheet will appear showing the teams you're currently part of, along with a ‘Join Team’ button in the top right—select this button to proceed.",
//         images: [joinTeam2],
//       },
//       {
//         text: "3. You'll be prompted to enter your team invite code. If you haven't received one, contact your team leader. Enter the code and tap ‘Join’ to continue.",
//         images: [joinTeam3],
//       },
//       {
//         text: "4. Your newly joined team will now appear in your list. Select it to access team resources and interact with other members.",
//         images: [joinTeam4],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Create a New Chat",
//     body: "Start a new chat by selecting users to message, optionally adding a title, and tapping Create Chat. Your new conversation will open and be ready to use.",
//     steps: [
//       {
//         text: "1. Tap the ‘Dashboard’ tab at the bottom of the screen, then select the message bubble icon in the top right corner.",
//         images: [createChat1],
//       },
//       {
//         text: "2. This takes you to your active chat threads. To start a new chat, tap the pencil and paper icon in the top right corner.",
//         images: [createChat2],
//       },
//       {
//         text: "3. Search for the user you want to chat with, then tap the ‘+’ button next to their name. You'll see them appear below the search text.",
//         images: [createChat3],
//       },
//       {
//         text: "4. If you’d like, you can add a title for your chat. Then, tap the ‘Create Chat’ button at the bottom of the screen. Your new chat will open—now just type your message and hit send.",
//         images: [createChat4],
//       },
//     ],
//     basicSub: true
//   }, 
//   {
//     title: "Share Team Code",
//     body: "Copy your team’s invite code from the Resources tab and share it with others. They can use the code to join your team instantly.",
//     steps: [
//       {
//         text: "1. Tap the ‘Resources’ tab from the options at the bottom. In the top right corner, select the gear icon (Note: if you are not the team creator, you will see the chainlink icon instead).",
//         images: [shareTeamLink1],
//       },
//       {
//         text: "2. You will see a section labeled ‘Invite Code’, tap the clipboard icon to copy the unique code.",
//         images: [shareTeamLink2],
//       },
//       {
//         text: "3. Share this code with your friends—they will use it to join your team!",
//         images: [],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Switch to New Teams",
//     body: "Switch between teams by tapping your current team name, selecting a different team from the list, and instantly accessing that team’s resources and content.",
//     steps: [
//       {
//         text: "1. Tap the ‘Resources’ tab from the four options at the bottom of the screen. In the top left corner, you’ll see your current team name with a dropdown arrow—Click on this.",
//         images: [switchTeams1], 
//       },
//       {
//         text: "2. A new sheet will appear with a list of the teams you’re a member of, with your currently selected team denoted with a checkbox.",
//         images: [switchTeams2],
//       },
//       {
//         text: "3. To switch teams, tap your preferred team from the list. The sheet will close, and you’ll now see the newly selected team’s resources with the team name displayed in the left corner.",
//         images: [switchTeams3],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "View Team Messages",
//     body: "Access your team’s chat thread to view or send messages. If you're an admin, you can post updates directly by typing in the message field and sending.",
//     steps: [
//       {
//         text: "1. Select the ‘Resources’ tab at the bottom, then tap the ‘Message’ icon in the top right.",
//         images: [viewTeamChat1], 
//       },
//       {
//         text: "2. This will open the team’s chat thread. Any messages sent will be visible here. If you have Admin privileges, you will be able to send messages as well.",
//         images: [viewTeamChat2],
//       },
//       {
//         text: "3. To send a message, simply tap on the text field at the bottom and begin typing. When you’re ready, select the blue send icon to the right to send your message.",
//         images: [viewTeamChat3],
//       },
//     ],
//     basicSub: true
//   }, 
//   {
//     title: "Schedule a Call",
//     body: "Schedule a call with a prospect by selecting their profile, entering call details and a date, and tapping Schedule. The call will appear in their call list.",
//     steps: [
//       {
//         text: "1. Tap the ‘Prospects’ tab at the bottom, then select the prospect you’d like to schedule a call with from your list.",
//         images: [scheduleCall1],
//       },
//       {
//         text: "2. In the prospect profile header at the top, you will see a row of icons. Select the phone icon.",
//         images: [scheduleCall2],
//       },
//       {
//         text: "3. You will navigate to a new screen—select the ‘+’ button in the top right corner.",
//         images: [scheduleCall3],
//       },
//       {
//         text: "4. A form will appear with required info. For online calls, enter the meeting link in the input field. For phone calls, toggle the switch and add the Prospect’s number.",
//         images: [scheduleCall4],
//       },
//       {
//         text: "5. Use the date picker to choose your preferred date and time. Click the date or time fields to make a selection.",
//         images: [scheduleCall5],
//       },
//       {
//         text: "6. If you have any relevant notes for your scheduled call, enter them in the Notes text field. Select the ‘Schedule’ button at the bottom.",
//         images: [scheduleCall6],
//       },
//       {
//         text: "7. Your scheduled call will now appear in your call list for the prospect!",
//         images: [],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Search for Boards",
//     body: "Search for a board by tapping the magnifying glass icon, entering the board name, and selecting it from the filtered results to view its content.",
//     steps: [
//       {
//         text: "1. Tap the ‘Resources’ tab from the options at the bottom. Click on the magnifying glass icon from the row of icons in the top right.",
//         images: [searchBoard1], 
//       },
//       {
//         text: "2. Click on the ‘Search Resources’ input field at the top, then begin entering the name of your board.",
//         images: [searchBoard2],
//       },
//       {
//         text: "3. A filtered list of boards related to your input will appear. Keep typing to narrow down the results. Once you find the board you’re looking for, click on it to view its content.",
//         images: [],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Reorder Dashboard Items",
//     body: "Reorder dashboard items by entering edit mode, dragging items into your preferred order, and saving the layout to customize your dashboard experience.",
//     steps: [
//       {
//         text: "1. Select the ‘Dashboard’ tab at the bottom, then tap the ‘Edit Dashboard’ button in the top right.",
//         images: [reorderDashboard1],
//       },
//       {
//         text: "2. To reorder your items, press and hold a dashboard item, then drag it to your preferred spot and drop it. As you move it, the other items will automatically shift to make room.",
//         images: [reorderDashboard2],
//       },
//       {
//         text: "3. When you’re done reordering your dashboard items, tap the ‘Done Editing’ button in the top right. This will save the order of your items.",
//         images: [reorderDashboard3],
//       },
//     ],
//   },
//   {
//     title: "Update Your Account",
//     body: "Update your account details by accessing Account Settings, editing your profile fields or monthly goal, and saving changes automatically by tapping the back arrow.",
//     steps: [
//       {
//         text: "1. Select the ‘Dashboard’ tab at the bottom, then tap on your profile picture in the top left corner.",
//         images: [updateAcccount1],
//       },
//       {
//         text: "2. The side menu will open with a list of options. Select ‘Settings,’ then tap ‘Account Settings’ within the Settings menu.",
//         images: [updateAcccount2],
//       },
//       {
//         text: "3. Your profile page will open with your information pre-filled. To make changes to your name, city, or social media, tap the relevant field and enter the updated details.",
//         images: [updateAcccount3],
//       },
//       {
//         text: "4. To update your monthly goal, tap on the dropdown to open it and select a new option from the list.",
//         images: [updateAcccount4],
//       },
//       {
//         text: "5. When you’re done, tap the back arrow in the top left corner. Your new information is automatically saved!",
//         images: [],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Upgrade Subscription",
//     body: "Upgrade to Pro by navigating to Manage Subscription, selecting the Go Pro option, reviewing benefits, and confirming your subscription through Apple to unlock premium features.",
//     steps: [
//       {
//         text: "1. Select the ‘Dashboard’ tab at the bottom, then tap on your profile picture in the top left corner.",
//         images: [upgradeSub1],
//       },
//       {
//         text: "2. The side menu will open with a list of options. Select ‘Settings,’ then tap ‘Manage Subscription’ within the Settings menu.",
//         images: [upgradeSub2],
//       },
//       {
//         text: "3. This will open the subscriptions screen. Tap on the ‘Go Pro’ label and read through the perks that come with the Pro Tier.",
//         images: [upgradeSub3],
//       },
//       {
//         text: "4. Tap the ‘Subscribe’ button at the bottom. Apple will prompt you to confirm your subscription. Follow Apple’s instructions to confirm your subscription. You are now a Pro Tier subscriber.",
//         images: [upgradeSub4],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Create a Reminder",
//     body: "",
//     steps: [
//       {
//         text: "1. Select the ‘Dashboard’ tab at the bottom, then tap on your profile picture in the top left corner.",
//         images: [scheduleReminder1], 
//       },
//       {
//         text: "2. This will open the side menu. Select ‘Reminders’ to navigate to the Reminders page. Any existing reminders will appear in a list.",
//         images: [scheduleReminder2],
//       },
//       {
//         text: "3. Tap the ‘+’ button in the top right corner. A new form will open labeled ‘Add a reminder’.",
//         images: [scheduleReminder3],
//       },
//       {
//         text: "4. Enter a title for your reminder in the first input field. Optionally, to link it to a prospect, start typing their name in the second field—a list of matching prospects will appear. Tap the one you want to select.",
//         images: [scheduleReminder4],
//       },
//       {
//         text: "5. If you’d like, enter more details for your reminder in the text field labeled ‘Description’. Use the date picker to choose your date and time. Click the date or time fields to make a selection.",
//         images: [scheduleReminder5],
//       },
//       {
//         text: "6. Choose the frequency of this reminder with the checkmark buttons. You can select this to be a one-time reminder or to occur every month.",
//         images: [scheduleReminder6],
//       },
//       {
//         text: "7. Tap the ‘Add Reminder’ button at the bottom. This will close the sheet and you will now see the reminder in your list.",
//         images: [scheduleReminder7],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Track Team Analytics",
//     body: "View team performance by accessing the dashboard stats. Track new prospects, actions, and conversions across the team, and explore individual member activity and contributions.",
//     steps: [
//       {
//         text: "1. Select the ‘Dashboard’ tab from the options at the bottom. In the top right corner, tap the bar chart icon.",
//         images: [dashboardStats1],
//       },
//       {
//         text: "Team Overview",
//         images: [],
//       },
//       {
//         text: "2. The ‘Team Overview’ tab will appear as selected. This page will include the number of new prospects your team has collectively created for the current month, along with prospect conversion data.",
//         images: [dashboardStats2],
//       },
//       {
//         text: "3. Tap the ‘New Prospect’ label to view a list of your top 5 team members with the most prospect creations this month. To close the list, swipe down on the top of your screen.",
//         images: [dashboardStats3],
//       },
//       {
//         text: "4. Below that, you'll also see team counts for Actions created by your team. Tap on these as well to view your most active members.",
//         images: [],
//       },
//       {
//         text: "Member Stats",
//         images: [],
//       },
//       {
//         text: "5. Select the ‘Member Stats’ label from the three options at the top. This will show a list of all your team members.",
//         images: [dashboardStats4],
//       },
//       {
//         text: "6. Scroll through the list and choose a member, or use the search bar to find a specific member. When you’ve found the member you’re looking for, tap on them.",
//         images: [],
//       },
//       {
//         text: "7. A new sheet will appear showing your team member’s monthly stats. These include new prospect count, prospect conversion count, and the Actions they’ve completed this month.",
//         images: [dashboardStats5],
//       },
//       {
//         text: "8. When you’re done, tap the ‘X’ button in the top right corner to close the sheet.",
//         images: [],
//       },
//     ]
//   },
//   {
//     title: "Turn On Chat Notifications",
//     body: "Turn on team chat notifications by opening the chat settings, toggling notification switches for each thread, and saving your changes to stay updated on team messages.",
//     steps: [
//       {
//         text: "1. Select the ‘Dashboard’ tab at the bottom, then tap the ‘Message’ icon in the top right.",
//         images: [teamChatNotif1],
//       },
//       {
//         text: "2. You will see a list of all your open team and individual chat threads. Tap the ‘Gear’ icon in the top right.",
//         images: [teamChatNotif2],
//       },
//       {
//         text: "3. Toggle selectors will now appear next to each chat thread. To enable notifications for a team, tap the toggle to turn it on. A red highlight indicates that notifications are active for that team.",
//         images: [teamChatNotif3],
//       },
//       {
//         text: "4. Tap the ‘Done Editing’ button in the top right corner. You have now turned on notifications for the selected team chats.",
//         images: [],
//       },
//     ],
//     basicSub: true
//   },
//   {
//     title: "Create a Language Board",
//     body: "Create a Language board by adding a title, content, and optional linked boards. Publish it to make it visible in your team’s Resources section.",
//     steps: [
//       {
//         text: "1. Tap the ‘Resources’ tab at the bottom, then click on the board where you’d like to add new content.",
//         images: [createLanguage1],
//       },
//       {
//         text: "2. At the bottom, select the circular ‘+’ button. This will open a window with available board options. Click the ‘Language’ option.",
//         images: [createLanguage2],
//       },
//       {
//         text: "3. Start by entering your title in the title field at the top. Then, add your main content in the larger text area labeled ‘Content’ below.",
//         images: [createLanguage3],
//       },
//       {
//         text: "4. When you’re ready, click ‘Publish’ in the top-right corner. To attach other boards, tap ‘Link Boards’ and select from the list that appears.",
//         images: [createLanguage4],
//       },
//       {
//         text: "5. You will see the new Language board in your resources!",
//         images: [createLanguage5],
//       },
//     ],
//   },
//   {
//     title: "Create a Link Board",
//     body: "Add a Link to a board by entering a name and URL, optionally uploading a cover photo, and tapping Add Link to display it in your team’s Resources.",
//     steps: [
//       {
//         text: "1. Tap the ‘Resources’ tab at the bottom, then click on the board where you’d like to add new content.",
//         images: [createLink1],
//       },
//       {
//         text: "2. At the bottom, select the circular ‘+’ button. This will open a window with available board options. Click the ‘Link’ option. This will open a new sheet.",
//         images: [createLink2],
//       },
//       {
//         text: "3. Optionally, enter a name for your link—this is how it will appear in your resources. Then paste the URL into the ‘Link’ field. A green checkmark will appear if the link is valid.",
//         images: [createLink3],
//       },
//       {
//         text: "4. If your URL lacks a thumbnail, you can upload a cover photo by tapping ‘Upload cover photo’. When ready, tap ‘Add Link’ at the bottom.",
//         images: [],
//       },
//       {
//         text: "5. You will now see the new Link in your resources.",
//         images: [createLink4],
//       },
//     ],
//   },
//   {
//     title: "Create a Photo Board",
//     body: "Add a photo to a board by selecting the Photo option, choosing an image from your gallery, and tapping Add. The photo will appear in your resources.",
//     steps: [
//       {
//         text: "1. Tap the ‘Resources’ tab at the bottom, then click on the board where you’d like to add new content.",
//         images: [createPhoto1], // Replace with your actual image variable
//       },
//       {
//         text: "2. At the bottom, select the circular ‘+’ button. This will open a window with available board options. Click the ‘Photo’ option. This will open your photo gallery if you’ve granted access.",
//         images: [createPhoto2],
//       },
//       {
//         text: "3. Tap on the desired photo from your gallery, then click ‘Add’ in the top right corner. This will add the photo to your resources.",
//         images: [createPhoto3],
//       },
//       {
//         text: "4. After adding the photo, you will see it in your resources!",
//         images: [createPhoto4],
//       },
//     ],
//   },
//   {
//     title: "Create a Checklist",
//     body: "Create a checklist by adding a title, steps with details, and optional board links. Publish it to make the checklist available in your team’s Resources.",
//     steps: [
//       {
//         text: "1. Tap the ‘Resources’ tab at the bottom, then click on the board where you’d like to add new content.",
//         images: [createChecklist1],
//       },
//       {
//         text: "2. At the bottom, select the circular ‘+’ button. This will open a window with available board options. Click the ‘List’ option.",
//         images: [createChecklist2],
//       },
//       {
//         text: "3. Enter a title for your list in the ‘Title’ field at the top. Next, add your first checklist step by typing a name in the ‘Label’ field and filling in the details in the ‘Content’ section below.",
//         images: [createChecklist3, createChecklist4],
//       },
//       {
//         text: "4. To add another step to the checklist, simply click the ‘Add’ button and fill out the information as you previously did. To link a board to the checklist step, click the ‘Link Boards’ button and select the desired boards.",
//         images: [],
//       },
//       {
//         text: "5. Once complete, click the ‘Publish’ button in the top right corner. You will now see the checklist in your resources.",
//         images: [createChecklist5, createChecklist6],
//       },
//     ],
//   },
//   {
//     title: "Create a Bar Chart Item",
//     body: "Add a Bar Chart to your dashboard by selecting data filters and metrics, customizing the chart’s design, and publishing it to visualize team activity and trends.",
//     steps: [
//       {
//         text: "1. On the Dashboard tab, select the ‘Edit Dashboard’ button in the top right. If you do not have dashboard items currently added, select ‘Add items’ on this tab and skip to step 3.",
//         images: [createBarChart1],
//       },
//       {
//         text: "2. Click the ‘+’ icon that appears on any of the current dashboard items. This will insert the new bar chart after it.",
//         images: [createBarChart2],
//       },
//       {
//         text: "3. This will open a list of the available dashboard items. Click on the ‘Bar Chart’ option.",
//         images: [createBarChart3],
//       },
//       {
//         text: "4. Select a ‘Data Filter’ and ‘Data Point to Track’ from the two dropdown menus.",
//         images: [createBarChart4],
//       },
//       {
//         text: "5. Once completed, the ‘Next’ button will become active. Click on this to go to the chart design page. Here, you can adjust the width, height, bar color, and orientation of your chart.",
//         images: [createBarChart5],
//       },
//       {
//         text: "6. When you’re ready, click the ‘Create Chart’ button at the bottom. You will now see this Bar chart on your dashboard!",
//         images: [],
//       },
//     ],
//   },
//   {
//     title: "Create a Boards List Item",
//     body: "Add a Boards List to your dashboard by selecting and linking boards, giving the list a title, and publishing it to easily access grouped content from one place.",
//     steps: [
//       {
//         text: "1. On the Dashboard tab, select the ‘Edit Dashboard’ button in the top right. If you do not have dashboard items currently added, select ‘Add items’ on this tab and skip to step 3.",
//         images: [boardListItem1], 
//       },
//       {
//         text: "2. Click the ‘+’ icon that appears on any of the current dashboard items. This will insert the new boards list after it.",
//         images: [boardListItem2],
//       },
//       {
//         text: "3. This will open a list of the available dashboard items. Click on the ‘Boards List’ option.",
//         images: [boardListItem3],
//       },
//       {
//         text: "4. A new sheet will open labeled ‘Create Boards List’. Enter your title in the field. Then, click the ‘Select Boards’ button.",
//         images: [boardListItem4],
//       },
//       {
//         text: "5. To link a board, simply click the square in the top right corner of each item. You may click the board itself to view and link items within. When finished, click the ‘Done’ button.",
//         images: [boardListItem5],
//       },
//       {
//         text: "6. Click the ‘Create Boards List’ button at the bottom. You will now see the list on your dashboard.",
//         images: [boardListItem6],
//       },
//     ],
//   },
//   {
//     title: "Create a Link Item",
//     body: "You can add external links to your dashboard by choosing the Link item type. Customize it with a title, URL, and optional cover photo to display.",
//     steps: [
//       {
//         text: "1. On the Dashboard tab, select the ‘Edit Dashboard’ button in the top right. If you do not have dashboard items currently added, select ‘Add items’ on this tab and skip to step 3.",
//         images: [linkDBItem1],
//       },
//       {
//         text: "2. Click the ‘+’ icon that appears on any of the current dashboard items. This will insert the new Link after it.",
//         images: [linkDBItem2],
//       },
//       {
//         text: "3. This will open a list of the available dashboard items. Click on the ‘Link’ option.",
//         images: [linkDBItem3],
//       },
//       {
//         text: "4. Optionally, enter a title for your link in the first field. Then, paste the URL into the second field. If the link doesn’t include a cover photo, you can add one by tapping ‘Upload Cover Photo’.",
//         images: [linkDBItem4],
//       },
//       {
//         text: "5. When you’re ready, click the ‘Add Link’ button at the bottom. You will see this new Link on your dashboard.",
//         images: [linkDBItem5],
//       },
//     ],
//   },
//   {
//     title: "Create a Graphic Item",
//     body: "Add a custom graphic to your dashboard by uploading an image, adjusting its size, and placing it alongside other items to visually enhance your dashboard layout.",
//     steps: [
//       {
//         text: "1. On the Dashboard tab, select the ‘Edit Dashboard’ button in the top right. If you do not have dashboard items currently added, select ‘Add items’ on this tab and skip to step 3.",
//         images: [graphicDBItem1], 
//       },
//       {
//         text: "2. Click the ‘+’ icon that appears on any of the current dashboard items. This will insert the new graphic after it.",
//         images: [graphicDBItem2],
//       },
//       {
//         text: "3. This will open a list of the available dashboard items. Click on the ‘Graphic’ option.",
//         images: [graphicDBItem3],
//       },
//       {
//         text: "4. A new sheet titled ‘Create Graphic’ will open. Optionally, enter a title for your graphic, then click ‘Select Graphic’ to choose an image.",
//         images: [graphicDBItem4],
//       },
//       {
//         text: "5. Your graphic will appear on the screen. Use the Width and Height sliders to adjust the dimensions of the graphic.",
//         images: [],
//       },
//       {
//         text: "6. When you’re ready, select the ‘Upload Graphic’ button at the bottom. Your graphic will now appear on your dashboard.",
//         images: [graphicDBItem5],
//       },
//     ],
//   },
//   {
//     title: "Create a Photo Grid Item",
//     body: "Create a Photo Grid on your dashboard by selecting images from your gallery, customizing the layout, and publishing it to visually showcase team content or highlights.",
//     steps: [
//       {
//         text: "1. On the Dashboard tab, select the ‘Edit Dashboard’ button in the top right. If you do not have dashboard items currently added, select ‘Add items’ on this tab and skip to step 3.",
//         images: [photoGridDBItem1],
//       },
//       {
//         text: "2. Click the ‘+’ icon that appears on any of the current dashboard items. This will insert the new photo grid after it.",
//         images: [photoGridDBItem2],
//       },
//       {
//         text: "3. This will open a list of the available dashboard items. Click on the ‘Photo Grid’ option.",
//         images: [photoGridDBItem3],
//       },
//       {
//         text: "4. Optionally, give your photo grid a title in the first input field. Then, click on the ‘Select Photos’ button.",
//         images: [photoGridDBItem4],
//       },
//       {
//         text: "5. Your photo gallery will open. Tap the images you wish to include—a checkbox will appear in the bottom right corner after selection. Then, click the ‘Add’ button at the top.",
//         images: [photoGridDBItem5],
//       },
//       {
//         text: "6. Your photo gallery will close and the selections will appear on the screen. When ready, click the ‘Create Photo Grid’ button at the bottom. You will now see it on your dashboard.",
//         images: [photoGridDBItem6],
//       },
//     ],
//   },
//   {
//     title: "Create a Prospect List Item",
//     body: "Add a Prospect List to your dashboard by selecting a data filter and generating a list preview. Save it to easily track targeted prospects from your dashboard view.",
//     steps: [
//       {
//         text: "1. On the Dashboard tab, select the ‘Edit Dashboard’ button in the top right. If you do not have dashboard items currently added, select ‘Add items’ on this tab and skip to step 3.",
//         images: [prospListDBitem1], 
//       },
//       {
//         text: "2. Click the ‘+’ icon that appears on any of the current dashboard items. This will insert the new prospect list after it.",
//         images: [prospListDBitem2],
//       },
//       {
//         text: "3. This will open a list of the available dashboard items. Click on the ‘Prospect List’ option.",
//         images: [prospListDBitem3],
//       },
//       {
//         text: "4. Tap ‘Select Data Filter’ and choose the data to base your list on. This will display a preview of your list.",
//         images: [prospListDBitem4],
//       },
//       {
//         text: "5. When ready, tap the ‘Create Prospect List’ button at the bottom of the page. You will now see your new prospect list on your dashboard.",
//         images: [],
//       },
//     ],
//   },
//   {
//     title: "Create a Label Item",
//     body: "Add a custom label to your dashboard to display helpful text or section headers. Enter your label, choose a size, and place it where needed.",
//     steps: [
//       {
//         text: "1. On the Dashboard tab, select the ‘Edit Dashboard’ button in the top right. If you do not have dashboard items currently added, select ‘Add items’ on this tab and skip to step 3.",
//         images: [labelDBItem1], 
//       },
//       {
//         text: "2. Click the ‘+’ icon that appears on any of the current dashboard items. This will insert the new Label after it.",
//         images: [labelDBItem2],
//       },
//       {
//         text: "3. This will open a list of the available dashboard items. Click on the ‘Label’ option.",
//         images: [labelDBItem3],
//       },
//       {
//         text: "4. Enter your label text in the first input field. You will see a preview of this label as you type.",
//         images: [labelDBItem4],
//       },
//       {
//         text: "5. To change the size of your label, click the ‘Label Size’ dropdown to view the available options. Select an option, and the label preview will update to reflect your choice.",
//         images: [labelDBItem5],
//       },
//       {
//         text: "6. When you’re ready, select the ‘Create Label’ button at the bottom. You will now see the new Label on your dashboard.",
//         images: [],
//       },
//     ],
//   },
//   {
//     title: "Create a Spacer Item",
//     body: "Use a Spacer to add visual separation between dashboard items. Adjust its height with a slider, then place it where you want to improve layout clarity.",
//     steps: [
//       {
//         text: "1. On the Dashboard tab, select the ‘Edit Dashboard’ button in the top right. If you do not have dashboard items currently added, select ‘Add items’ on this tab and skip to step 3.",
//         images: [createSpacer1],
//       },
//       {
//         text: "2. Click the ‘+’ icon that appears on any of the current dashboard items. This will insert the spacing after it.",
//         images: [createSpacer2],
//       },
//       {
//         text: "3. This will open a list of the available dashboard items. Click on the ‘Spacer’ option.",
//         images: [createSpacer3],
//       },
//       {
//         text: "4. A new sheet will appear with two sample ‘Dashboard Element’ blocks. These show how much space you're adding between existing dashboard items.",
//         images: [],
//       },
//       {
//         text: "5. Use the slider on the screen to adjust the height of the spacer. As you slide, you will see the spacing adjust between the two elements.",
//         images: [createSpacer4],
//       },
//       {
//         text: "6. When you’re ready, select the ‘Create Spacer’ button. This will add the spacer after the dashboard item you selected the ‘+’ button for.",
//         images: [],
//       },
//     ],
//   },
//   {
//     title: "Add Committees",
//     body: "Create a new committee within your team settings to organize members into focused groups. Committees support structured collaboration and can have members assigned in a separate step",
//     steps: [
//       {
//         text: "1. Select the ‘Resources’ tab at the bottom, then tap the gear icon in the top right corner.",
//         images: [addCommittee1],
//       },
//       {
//         text: "2. Tap the ‘Configuration’ tab and scroll to the ‘Team Committees’ item and select it.",
//         images: [addCommittee2],
//       },
//       {
//         text: "3. Click the ‘+’ button, then enter your new committee name in the input field and select the ‘Done’ button.",
//         images: [addCommittee3],
//       },
//       {
//         text: "4. Your new committee has been added. To assign members to the committee, view the ‘Assign Committee Members’ tutorial.",
//         images: [],
//       },
//     ],
//   },
//   {
//     title: "Add a Product",
//     body: "Add a new team product by entering a name and optional photo. Products help represent what your team offers and appear in team configuration and reports",
//     steps: [
//       {
//         text: "1. Select the ‘Resources’ tab at the bottom, then tap the gear icon in the top right corner.",
//         images: [addProduct1],
//       },
//       {
//         text: "2. Tap the ‘Configuration’ tab and scroll to the ‘Team Products’ item and select it.",
//         images: [addProduct2],
//       },
//       {
//         text: "3. Click the ‘+’ button in the top right corner. Then enter your new product name in the input field and add a product photo if you have one. When you’re ready, select the ‘Done’ button.",
//         images: [addProduct3],
//       },
//       {
//         text: "4. Your new product has been added to your team.",
//         images: [],
//       },
//     ],
//   },
//   {
//     title: "Add Team Actions",
//     body: "Create a new team action to track key tasks or goals. Customize it with a name and color to support organization, clarity, and team accountability",
//     steps: [
//       {
//         text: "1. Select the ‘Resources’ tab at the bottom, then tap the gear icon in the top right corner.",
//         images: [addAction1],
//       },
//       {
//         text: "2. Tap the ‘Configuration’ tab and scroll to the ‘Team Actions’ item and select it.",
//         images: [addAction2],
//       },
//       {
//         text: "3. Click the ‘+’ button in the top right corner. Then enter your new action in the input field. Additionally, use the color wheel to give your action a distinct color. Tap the ‘Done’ button when you’re ready.",
//         images: [addAction3, addAction4],
//       },
//       {
//         text: "4. Your new action has been added to your team.",
//         images: [],
//       },
//     ],
//   },
//   {
//     title: "Add a Team Goal",
//     body: "Create a team goal by setting a title and monthly action targets. Goals help measure progress and are automatically saved for ongoing tracking through the team dashboard",
//     steps: [
//       {
//         text: "1. Select the ‘Resources’ tab at the bottom, then tap the gear icon in the top right corner.",
//         images: [addGoal1],
//       },
//       {
//         text: "2. Tap the ‘Configuration’ tab and scroll to the ‘Team Goals’ item and select it.",
//         images: [addGoal2],
//       },
//       {
//         text: "3. Click the ‘Add Goal’ button in the top right corner, then enter your goal title and the monthly values per team action to achieve this goal.",
//         images: [addGoal3],
//       },
//       {
//         text: "4. Your new team goal is automatically saved. You may begin tracking your team’s progress toward this goal from the dashboard!",
//         images: [],
//       },
//     ],
//   },
//   {
//     title: "Create a New Team",
//     body: "Create a new team by defining its structure, including categories, statuses, and goals. Customize team settings, then finalize setup to enable collaboration and dashboard tracking",
//     steps: [
//       {
//         text: "1. Tap the ‘Resources’ tab from the options at the bottom. In the top left corner, you’ll see your current team name with a dropdown arrow in the top left—Click on this.",
//         images: [createTeam1],
//       },
//       {
//         text: "2. A sheet will appear showing the teams you're currently part of, along with a ‘New Team’ button in the top right—select this button to proceed.",
//         images: [createTeam2],
//       },
//       {
//         text: "3. Start by entering your team name in the input field. Then, use the emoji picker to select one for your team. Tap the ‘Next’ button when you’re ready.",
//         images: [createTeam3],
//       },
//       {
//         text: "4. Next, you will be prompted to create a board for your team. View the ‘Create a New Board’ tutorial for a walkthrough on how to do this. This step is optional at team creation and may be completed at a later time.",
//         images: [createTeam4]
//       },
//       {
//         text: "5. Next is the team configuration step. You must add at least one category and one status to create a team. For guidance, refer to the ‘Add New Category’ and ‘Add New Status’ tutorials. (link)",
//         images: [createTeam5]
//       },
//       {
//         text: "6. You can also create committees, products, actions, and goals in this step. Refer to the tutorials named –- Add a committee, Add a Product, Add a Team Action, Add a Team goal, for help creating the configuration items.",
//         images: [createTeam6]
//       },
//       {
//         text: "7. Lastly, you can start creating Dashboard Items that will appear on each team member’s dashboard. Tap ‘Create Dashboard Item’ to view a list of available items. For help creating each one, search for the dashboard item’s name in the tutorial list to find the related guide.",
//         images: []
//       },
//       {
//         text: "8. When you’re ready, tap the ‘Done’ button at the button, you will see a new screen with a message saying ‘Team Setup Complete!’",
//         images: [createTeam7]
//       },
//     ],
//   }
// ];
